<template>
    <div class="main">
        <div ref="getQueryHeight">
            <!--查询按钮-->
            <div class="queryButton">
                <a-col>
                    <img class="funcButton" src="../../assets/img/search.png" width="22" height="22" @click="query" :title="$t('batchReceive.Query')">
                    <img class="funcButton" src="../../assets/img/refresh2.png" width="22" height="22" @click="reset" :title="$t('pubGicSet.Clear')">
                </a-col>
            </div>

            <!--查询条件-->
            <div>
                <a-form :form="formQuery">
                    <div class="queryParam">
                        <a-form-item class="genericFrom" label="Rec Id:">
                            <a-input size="small" v-decorator="['recId']" @pressEnter="query"/>
                        </a-form-item>
                    </div>
                    <div class="queryParam">
                        <a-form-item class="genericFrom" label="Status">
                            <a-select
                                    style="width: 150px;"
                                    size="small"
                                    v-decorator="['status']">
                                <a-select-option :value="item.CODE" v-for="item in localData.ASN_STATUS">{{item.CODE_DESC}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </div>
                    <div class="queryParam">
                        <a-form-item class="genericFrom" label="Asn Date">
                            <a-date-picker
                                    size="small"
                                    placeholder='Asn Date'
                                    style="width: 100%"
                                    allowClear
                                    format="YYYY-MM-DD"
                                    v-decorator="['asnDate',]">
                            </a-date-picker>
                        </a-form-item>
                    </div>
                    <div class="queryParam">
                        <a-form-item label="SKU" class="genericFrom">
                            <a-input-search size="small" style="width: 100%;" v-model="querySkuCode" @search="skuSearch" />
                        </a-form-item>
                    </div>
                </a-form>
            </div>

            <div class="pagination">
                <!--功能按钮-->
                <div style="float:left;padding-top: 2px;">
                    <img class="funcButton" src="../../assets/img/ss-add.png" width="20" height="20" @click="addShow" :title="$t('generic.Add')">
                    <img class="funcButton" src="../../assets/img/ss-delete.png" width="20" height="20" @click="deletes" :title="$t('generic.Delete')">
                    <img class="funcButton" src="../../assets/img/ss-save.png" width="20" height="20" @click="saveEditData" :title="$t('userlang.Save')">
                    <!--More-->
                    <a-dropdown>
                        <a class="ant-dropdown-link">
                            <img class="funcButton" src="../../assets/img/ss-more.png" width="20" height="20">
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item style="font-size: 12px">
                                <a-icon type="zoom-in" /> Print SSCC Label
                            </a-menu-item>
                            <a-menu-item style="font-size: 12px">
                                <a-icon type="ordered-list" /> 上传文件
                            </a-menu-item>
                            <a-menu-item style="font-size: 12px">
                                <a-icon type="table" /> 下载文件
                            </a-menu-item>
                            <a-sub-menu>
                                <span slot="title"><a-icon type="lock" /> 更多</span>
                                <a-menu-item> 11111</a-menu-item>
                                <a-menu-item> 22222</a-menu-item>
                                <a-menu-item> 33333</a-menu-item>
                                <a-menu-item> 44444</a-menu-item>
                                <a-menu-item> 55555</a-menu-item>
                                <a-menu-item> 66666</a-menu-item>
                            </a-sub-menu>
                        </a-menu>
                    </a-dropdown>
                </div>

                <!--分页-->
                <div style="width: 650px;float: right;text-align: right;padding-top: 2px;">
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => `Total ${pagingTotal}  Records`"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            :showSizeChanger="showSizeChanger"
                            :showQuickJumper="showQuickJumper"
                    />
                </div>
            </div>
        </div>
        <!--查询列表-->
        <div class="PagingGrid">
            <vxe-table
                    border
                    resizable
                    stripe
                    column-key
                    highlight-hover-column
                    highlight-hover-row
                    highlightCurrentRow
                    show-header-overflow
                    show-overflow
                    @cell-dblclick="editShow"
                    :sort-config="{multiple: true, trigger: 'cell'}"
                    :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                    keep-source
                    :keyboard-config="{isArrow: true}"
                    :checkbox-config="{trigger: 'row', highlight: true, range: true}"
                    align="center"
                    :data.sync="PagingGridList"
                    class="mytable-style "
                    :max-height="getMainHeight"
                    ref="refPagingGrid"
                    size="mini">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
                <vxe-table-column field="recId" :title="$t('pubGicSet.RecID')" width="150" sortable></vxe-table-column>
                <vxe-table-column field="status" :title="$t('menu.Status')" width="100" sortable></vxe-table-column>
                <vxe-table-column field="poNo" :title="$t('publicLang.No')" width="150" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                <vxe-table-column field="orderType" :title="$t('pubGicSet.OrderType')" width="100" sortable></vxe-table-column>
                <vxe-table-column field="qty" title="Qty" width="100" sortable></vxe-table-column>
                <vxe-table-column field="asnDate" title="Asn Date" width="200" :formatter="formatTime" sortable></vxe-table-column>
                <vxe-table-column field="ref01" title="Ref Num1" width="120" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                <vxe-table-column field="ref02" title="Ref Num2" width="120" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                <vxe-table-column field="ref03" title="Ref Num3" width="120" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                <vxe-table-column field="ref04" title="Ref Num4" width="120" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                <vxe-table-column field="ref05" title="Ref Num5" width="120" sortable :edit-render="{name: 'input'}"></vxe-table-column>
                <vxe-table-column field="creator" :title="$t('generic.Creator')" width="200" sortable></vxe-table-column>
                <vxe-table-column field="createTime" :title="$t('generic.CreateTime')" width="200" :formatter="formatTime" sortable></vxe-table-column>
                <vxe-table-column field="modifier" :title="$t('generic.Modifier')" width="200" sortable></vxe-table-column>
                <vxe-table-column field="modifyTime" :title="$t('generic.ModifyDate')" width="200" :formatter="formatTime" sortable></vxe-table-column>
            </vxe-table>
        </div>

        <!--新增/修改弹窗-->
        <div class="tabsTables" v-show="showAdd" style="width: 80%">
            <a-row type="flex" justify="space-between" align="middle" class="tabeHeader">
                <a-col class="zitiClass" style="font-size: 15px;font-weight: 600;">{{tabsTitle}}</a-col>
                <a-col @click="onClose" class="ztColor sbxs"><a-icon type="close" style="font-size: 16px;" /></a-col>
            </a-row>
            <a-tabs :animated="animated" @tabClick="tabClick" v-model="targetActive">
                <a-tab-pane tab="Header" key='headerKey'>
                    <a-form :form="formHeader">
                        <a-row :gutter="24">
                            <a-collapse v-model="activeKey" :bordered="false">
                                <a-collapse-panel :key="'1'" header="Group 1">
                                    <a-row>
                                        <a-col span="8" offset="3">
                                            <a-form-item class="genericFrom" label="UID" v-show="false">
                                                <a-input v-decorator="[
                                                    'uid',
                                                    {
                                                        initialValue: this.headerData == null ? '' : this.headerData.uid
                                                    }]
                                                "/>
                                            </a-form-item>
                                            <a-form-item class="genericFrom" label="Asn No">
                                                <a-input size="small" placeholder="Asn No" autocomplete="off" style="width: 100%;"
                                                    v-decorator="[
                                                    'recId',
                                                    {
                                                        initialValue: this.headerData == null ? '' : this.headerData.recId,
                                                        rules: [
                                                            {
                                                              required: true,
                                                              message: $t('publicLang.Required'),
                                                            }
                                                        ]
                                                    }]
                                            "/>
                                            </a-form-item>
                                            <a-form-item class="genericFrom" label="Status">
                                                <a-input size="small" placeholder="Status" autocomplete="off" style="width: 100%;"
                                                    v-decorator="[
                                                    'status',
                                                    {
                                                        initialValue: this.headerData == null ? '' : this.headerData.status,
                                                        rules: [
                                                            {
                                                              required: true,
                                                              message: $t('publicLang.Required'),
                                                            }
                                                        ]
                                                    }]
                                            "/>
                                            </a-form-item>
                                        </a-col>
                                        <a-col span="8" offset="3">
                                            <a-form-item class="genericFrom" label="Asn Date">
                                                <a-date-picker
                                                        size="small"
                                                        placeholder="Asn Date"
                                                        style="width: 100%"
                                                        allowClear
                                                        format="YYYY-MM-DD"
                                                        v-decorator="[
                                                        'asnDate',
                                                            {
                                                              initialValue:this.headerData == null ? '' : this.headerData.asnDate == null ?  moment(new Date(), 'YYYY-MM-DD') : moment(this.headerData.asnDate, 'YYYY-MM-DD'),
                                                            }
                                                        ]"
                                                >
                                                </a-date-picker>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-collapse-panel>

                                <a-collapse-panel :key="'2'" header="Group 2">
                                    <a-row>
                                        <a-col span="8" offset="3">
                                            <a-form-item class="genericFrom" label="Ref01">
                                                <a-input size="small" placeholder="Ref01" autocomplete="off" style="width: 100%;"
                                                    v-decorator="[
                                                    'ref01',
                                                    {
                                                        initialValue: this.headerData == null ? '' : this.headerData.ref01
                                                    }]
                                            "/>
                                            </a-form-item>
                                            <a-form-item class="genericFrom" label="Ref02">
                                                <a-input size="small" placeholder="Ref02" autocomplete="off" style="width: 100%;"
                                                    v-decorator="[
                                                    'ref02',
                                                    {
                                                        initialValue: this.headerData == null ? '' : this.headerData.ref02
                                                    }]
                                            "/>
                                            </a-form-item>
                                        </a-col>
                                        <a-col span="8" offset="3">
                                            <a-form-item class="genericFrom" label="备注">
                                                <a-textarea size="small" autocomplete="off"
                                                    v-decorator="[
                                                    'remarks',
                                                    {
                                                        initialValue: this.headerData == null ? '' : this.headerData.remarks
                                                    }]
                                            "/>
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-collapse-panel>

                            </a-collapse>
                        </a-row>
                    </a-form>
                    <div style="cursor:pointer; float: right;margin:10px;">
                        <a-button size="small" type="primary" @click="saveAsn" icon="save">{{$t('publicLang.Save')}}</a-button>
                    </div>
                </a-tab-pane >

                <a-tab-pane tab="Detail" key='detailKey'>
                    <div class="pagination">
                        <!--功能按钮-->
                        <div style="float:left;padding-top: 2px;">
                            <img class="funcButton" src="../../assets/img/ss-add.png" width="20" height="20" @click="addShowDetail" :title="$t('generic.Add')">
                            <img class="funcButton" src="../../assets/img/ss-delete.png" width="20" height="20" @click="deletesDetail" :title="$t('generic.Delete')">
                            <!--更多-->
                            <a-dropdown>
                                <a class="ant-dropdown-link">
                                    <img class="funcButton" src="../../assets/img/ss-more.png" width="20" height="20">
                                </a>
                                <a-menu slot="overlay">
                                    <a-menu-item style="font-size: 12px">
                                        <a-icon type="zoom-in" /> 功能按钮
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </div>

                        <!--分页-->
                        <div style="width: 650px;float: right;text-align: right;padding-top: 2px;">
                            <a-pagination
                                    :pageSizeOptions="pageSizeOptions"
                                    :showTotal="total => `Total ${pagingDetailTotal}  Records`"
                                    size="small"
                                    :total="pagingDetailTotal"
                                    v-model="currentDetailVal"
                                    :pageSize.sync="pagingDetailSize"
                                    @change="tableDetailChangePage"
                                    @showSizeChange="onShowSizeDetailChange"
                                    :showSizeChanger="showSizeChanger"
                                    :showQuickJumper="showQuickJumper"
                            />
                        </div>
                    </div>
                    <!--弹出窗明细查询列表-->
                    <vxe-table
                            border
                            resizable
                            stripe
                            highlightHoverRow
                            highlightCurrentRow
                            highlightCurrentColumn
                            @cell-dblclick="editDetailShow"
                            align="center"
                            :data.sync="PagingGridDetailList"
                            class="mytable-style "
                            :max-height="getMainHeight"
                            ref="refDetailPagingGrid"
                            size="mini">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                        <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="ellipsis" :visible="false"></vxe-table-column>
                        <vxe-table-column field="line_no" :title="$t('batchReceive.Line')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                        <vxe-table-column field="status" :title="$t('menu.Status')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                        <vxe-table-column field="sku" :title="$t('batchReceive.SKU')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="150"></vxe-table-column>
                        <vxe-table-column field="asn_line_seq" title="ASN Line Seq" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                        <vxe-table-column field="asn_qty" :title="$t('pubGicSet.ASNQty')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                        <vxe-table-column field="asn_base_qty" :title="$t('batchReceive.ASNBaseQty')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                        <vxe-table-column field="rec_qty" :title="$t('batchReceive.RecQty')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                        <vxe-table-column field="rec_base_qty" :title="$t('batchReceive.RecBaseQty')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="100"></vxe-table-column>
                        <vxe-table-column field="creator" :title="$t('generic.Creator')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="200"></vxe-table-column>
                        <vxe-table-column field="create_time" :title="$t('generic.CreateTime')" width="200" :formatter="formatTime"></vxe-table-column>
                        <vxe-table-column field="modifier" :title="$t('generic.Modifier')" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="200"></vxe-table-column>
                        <vxe-table-column field="modify_time" :title="$t('generic.ModifyDate')" width="200" :formatter="formatTime"></vxe-table-column>
                    </vxe-table>
                </a-tab-pane >
            </a-tabs>
        </div>

        <!--ASN明细的新增/修改弹窗-->
        <div class="tabsTables" v-show="showAddDetail">
            <a-row type="flex" justify="space-between" align="middle" class="tabeHeader">
                <a-col class="zitiClass" style="font-size: 15px;font-weight: 600;">{{tabsTitleDetail}}</a-col>
                <a-col @click="onCloseDetail" class="ztColor sbxs"><a-icon type="close" style="font-size: 16px;" /></a-col>
            </a-row>
            <a-form :form="formDetail" style="margin-left: 12px;">
                <a-row :gutter="24">
                    <a-collapse v-model="activeKey" :bordered="false">
                        <a-collapse-panel :key="'1'" header="Group 1">
                            <a-row>
                                <a-form-item class="genericFrom" label="UID" v-show="false">
                                    <a-input v-decorator="[
                                            'uid',
                                            {
                                                initialValue: this.detailData == null ? '' : this.detailData.uid
                                            }]
                                        "/>
                                </a-form-item>
                                <a-form-item class="genericFrom" label="AsnUID" v-show="false">
                                    <a-input v-decorator="[
                                            'asnHeaderUid',
                                            {
                                                initialValue: this.currentUid
                                            }]
                                        "/>
                                </a-form-item>
                            </a-row>
                            <a-row>
                                <a-col span="8" offset="3">
                                    <a-form-item class="genericFrom" label="SKU">
                                        <a-input size="small" placeholder="SKU" autocomplete="off" style="width: 100%;"
                                                 v-decorator="[
                                            'sku',
                                            {
                                                initialValue: this.detailData == null ? '' : this.detailData.sku,
                                                rules: [
                                                    {
                                                      required: true,
                                                      message: $t('publicLang.Required'),
                                                    }
                                                ]
                                            }]
                                        "/>
                                    </a-form-item>
                                </a-col>
                                <a-col span="8" offset="3">
                                    <a-form-item class="genericFrom" label="Qty">
                                        <a-input size="small" placeholder="Qty" autocomplete="off" style="width: 100%;"
                                                 v-decorator="[
                                            'asnQty',
                                            {
                                                initialValue: this.detailData == null ? '' : this.detailData.asnQty,
                                                rules: [
                                                    {
                                                      required: true,
                                                      message: $t('publicLang.Required'),
                                                    }
                                                ]
                                            }]
                                    "/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-collapse-panel>
                    </a-collapse>
                </a-row>
            </a-form>
            <div style="cursor:pointer; float: right;margin:10px;">
                <a-button size="small" type="primary" @click="saveAsnDetail" icon="save">{{$t('publicLang.Save')}}</a-button>
            </div>
        </div>

        <!--SKU查询弹出窗-->
        <search-sku ref="querySkuWindow" @checkedSkuCode="checkedSkuCode"></search-sku>

    </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
import store from "../../store";
import Template from "./reportCom/template";
import searchSku from "./components/searchSku";
import moment from "moment";
import XEUtils from 'xe-utils'
import Sortable from "sortablejs";
import cookie from '../../api/cookie';

export default{
    components: {
        Template,
        searchSku,
    },
    data(){
        return{
            pagingTotal: 0, // 总数
            pagingDetailTotal: 0, // 总数
            pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
            pagingDetailSize: 30, // 条数
            currentVal: 1, // 当前选中的页数
            currentDetailVal: 1, // 当前选中的页数
            showSizeChanger:true,//是否显示页码下拉框
            showQuickJumper:true,//是否显示快速跳转输入框
            targetUID: null, // 点击表格转给弹窗uid
            showTitleValue: [],
            parTabelEditVerSion: null, // table 版本号
            tabsActive: '0',
            PagingGridList: [],//列表数据
            PagingGridDetailList: [],//明细列表数据
            queryHeight:0,//查询条件div高度
            pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
            showAdd:false,
            showAddDetail:false,
            tabsTitle:"",//弹出窗口标题
            tabsTitleDetail:"",//弹出窗口标题
            targetActive: 'headerKey', // 当前tabs选中卡
            currentUid:'',//双击选择的数据UID
            currentDetailUid:'',//双击选择的数据UID
            animated: true, // 关闭动画
            activeKey: [1,2], // 分组下标:填写下标则展开
            formItemLayout: {},
            formHeader: this.$form.createForm(this, {}),
            formDetail: this.$form.createForm(this, {}),
            formQuery: this.$form.createForm(this, {}),
            headerData:{},
            detailData:{},
            localData: {},
            querySkuCode:"",
        }
    },
    mounted() {
        this.queryHeight = this.$refs.getQueryHeight.clientHeight;//获取查询条件div的高度
    },
    computed:{
        getMainHeight(){
            return document.body.clientHeight - 80 - this.queryHeight;//自适应查询列表的高度
        },
    },
    methods:{
        moment,
        query(){
            this.currentVal = 1;
            this.init();
        },
        init(){
            this.showAdd = false;
            this.formQuery.validateFields((err, values) => {
                if(err){
                    this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 3);
                    return;
                }
                if(values){
                    let params = {//配置查询条件
                        condition:values,
                        currentVal: (this.currentVal - 1) * this.pagingSize,
                        pagingSize:this.pagingSize,
                        skuCode:this.querySkuCode,
                    }
                    ajax.get(api.ASNLIST,params).then(res=>{
                        if(res.code == 200){
                            this.PagingGridList = res.data;//列表
                            this.pagingTotal = res.total;//总数
                        }
                    })
                }
            });
        },
        initDetail(){
            this.showAddDetail = false;
            let params = {//配置查询条件
                currentVal: this.currentVal - 1,
                pagingSize: this.pagingSize,
                currentUid: this.currentUid
            }
            ajax.get(api.ASNDETAILLIST,params).then(res=>{
                if(res.code == 200){
                    this.PagingGridDetailList = res.data;//列表
                    this.pagingDetailTotal = res.total;//总数
                }
            })
        },
        formatTime ({cellValue}) {
            return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:ss:mm')
        },
        reset(){//重置
            this.formQuery.resetFields();
            this.querySkuCode = "";
        },
        onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
            this.currentVal = current;
            this.pagingSize = pageSize;
            this.init();
        },
        onShowSizeDetailChange(current, pageSize) {//选择下拉框后触发事件
            this.currentDetailVal = current;
            this.pagingDetailSize = pageSize;
            this.initDetail();
        },
        tableChangePage(current) {
            this.currentVal = current;
            this.init();
        },
        tableDetailChangePage(current) {
            this.currentDetailVal = current;
            this.initDetail();
        },
        addShow(){//弹出新增窗口
            this.showAdd = true;
            this.tabsTitle = "Add";
            this.headerData = null;//清空当前选中主表数据
            this.currentUid = '';
            this.targetActive = 'headerKey';
            this.formHeader.resetFields();
        },
        addShowDetail(){//弹出新增窗口
            if(this.currentUid == ''){
                this.$customMessage.warning(this.$t('asnPage.saveHeaderPlease'), 3);
                return;
            }
            this.showAddDetail = true;
            this.tabsTitleDetail = "Add - Detail";
            this.detailData = null;//清空当前选中明细表数据
            this.formDetail.resetFields();
        },
        editShow({ row }) {//双击弹出修改窗口
            this.showAdd = true;
            this.showAddDetail = false;
            this.tabsTitle = "Edit - " + row.recId;
            this.currentUid = row.uid;
            //默认查询ASN主表数据
            this.formHeader.resetFields();
            this.tabClick('headerKey');
        },
        editDetailShow({ row }) {//双击明细弹出修改窗口
            this.showAddDetail = true;
            this.tabsTitleDetail = "Edit - Detail - " + row.recId;
            this.currentDetailUid = row.uid;
            //默认查询ASN主表数据
            this.formDetail.resetFields();
            let params = {//查询当前选中ASN的明细表数据
                uid: this.currentDetailUid
            }
            ajax.get(api.ASNDETAIL,params).then(res=>{
                this.detailData = res;
            })
        },
        tabClick(val) {//点击弹出窗口的Tab事件
            if(val == 'headerKey'){//Query Header
                let params = {//查询当前选中ASN的主表数据
                    uid: this.currentUid
                }
                ajax.get(api.ASNHEADER,params).then(res=>{
                    this.headerData = res;
                })
            }else if(val == 'detailKey'){//Query Detail List
                this.initDetail();
            }
            this.targetActive = val;
        },
        saveAsn(){//保存Asn主表数据
            this.formHeader.validateFields((err, values) => {
                if(err){
                    this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 3);
                    return;
                }
                if(values){
                    console.log(values);
                    ajax.post(api.ASNSAVEHEADER, values).then(res => {
                        if (res.code == 200) {
                            this.init()
                            this.$message.success(res.msg)
                        } else {
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }
            });
        },
        saveAsnDetail(){//保存Asn明细表数据
            this.formDetail.validateFields((err, values) => {
                if(err){
                    this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 3);
                    return;
                }
                if(values){
                    ajax.post(api.ASNSAVEDETAIL, values).then(res => {
                        if (res.code == 200) {
                            this.initDetail()
                            this.$message.success(res.msg)
                        } else {
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }
            });
        },
        deletes(){//删除
            let Records = this.$refs.refPagingGrid.getCheckboxRecords()
            if(Records.length == 0){
                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                return;
            }
            let uidList = [];
            for(let i in Records){
                uidList.push(Records[i].uid)
            }
            let that = this;
            this.$customConfirm({
                title: this.$t('pubGicSet.AreyoudeleTask'),
                okText: that.$t('publicLang.Confirm'),
                cancelText: that.$t('publicLang.Cancel'),
                content: "",
                onOk() {
                    let params = new FormData();
                    params.append("uidList", uidList);
                    store.commit("updataLoading", {pbLoading: true});
                    ajax.post(api.DELETELIST, params).then(res => {
                        store.commit("updataLoading", {pbLoading: false});
                        if (res.code == 200) {
                            that.init()
                            that.$message.success(that.$t("publicLang.DeleteSuccess"));
                        } else {
                            that.$customMessage.warning(res.msg);
                        }
                    })
                }
            });
        },
        deletesDetail(){//删除
            let Records = this.$refs.refDetailPagingGrid.getCheckboxRecords()
            if(Records.length == 0){
                this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                return;
            }
            let uidList = [];
            for(let i in Records){
                uidList.push(Records[i].uid)
            }
            let that = this;
            this.$customConfirm({
                title: that.$t('pubGicSet.AreyoudeleTask'),
                okText: that.$t('publicLang.Confirm'),
                cancelText: that.$t('publicLang.Cancel'),
                content: "",
                onOk() {
                    let params = new FormData();
                    params.append("uidList", uidList);
                    store.commit("updataLoading", {pbLoading: true});
                    ajax.post(api.DELETEDETAILLIST, params).then(res => {
                        store.commit("updataLoading", {pbLoading: false});
                        if (res.code == 200) {
                            that.initDetail()
                            that.$message.success(that.$t("publicLang.DeleteSuccess"));
                        } else {
                            that.$customMessage.error(res.msg);
                        }
                    })
                }
            });
        },
        saveEditData(){
            let updateRecords = this.$refs.refPagingGrid.getUpdateRecords();//获取修改行数据
            if(updateRecords.length == 0){
                this.$customMessage.warning(this.$t('asnPage.saveData'), 3);
                return;
            }
            let index = updateRecords.length
            let add = 0;
            updateRecords.filter((item) => {//实际使用中可以通过updateRecords传参
                ajax.post(api.ASNSAVEHEADER, item).then(res => {
                    add ++;
                    if(add == index){
                        if (res.code == 200) {
                            this.init()
                            this.$message.success(res.msg)
                        } else {
                            this.$customMessage.warning(res.msg);
                        }
                    }
                })
            })
        },
        columnDrop () {//Table列托动
            this.$nextTick(() => {
                const xTable = this.$refs.refPagingGrid
                this.sortable = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {})
                this.sortable = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
                    handle: '.vxe-header--column:not(.col--fixed)',
                    onEnd: ({item, newIndex, oldIndex}) => {
                        this.$XModal.alert("Welcome!");
                        const {fullColumn, tableColumn} = xTable.getTableColumn()
                        const targetThElem = item
                        const wrapperElem = targetThElem.parentNode
                        const newColumn = fullColumn[newIndex]
                        if (newColumn.fixed) {
                            // 错误的移动
                            if (newIndex > oldIndex) {
                                wrapperElem.insertBefore(targetThElem, wrapperElem.children[oldIndex])
                            } else {
                                wrapperElem.insertBefore(wrapperElem.children[oldIndex], targetThElem)
                            }
                            return this.$XModal.message({message: '固定列不允许拖动！', status: 'error'})
                        }
                        // 转换真实索引
                        const oldColumnIndex = xTable.getColumnIndex(tableColumn[oldIndex])
                        const newColumnIndex = xTable.getColumnIndex(tableColumn[newIndex])
                        // 移动到目标列
                        const currRow = fullColumn.splice(oldColumnIndex, 1)[0]
                        fullColumn.splice(newColumnIndex, 0, currRow)
                        xTable.loadColumn(fullColumn)
                    }
                })
            })
        },
        skuSearch(){
            this.$refs.querySkuWindow.show(this.querySkuCode)
        },
        checkedSkuCode(val) {
            this.querySkuCode = val;
        },
        onClose() {//关闭主表弹窗
            this.showAdd = false;
        },
        onCloseDetail(){//关闭明细弹窗
            this.showAddDetail = false;
        }
    },
    created() {
        // this.$XModal.alert("Welcome!");
        this.reset();
        this.query();
        this.localData = JSON.parse(sessionStorage.getItem('localData'))//获取下拉框中的值
        this.columnDrop();
    },
    beforeDestroy() {
        if(this.sortable){
            this.sortable.destroy();
        }
    }
}
</script>

<style scoped>
    .main{
        width: 100%;
        height: 100%;
        background-color: white;
        float: left;
    }
    .queryButton{
        border: 1px solid #e8eaec;
        padding:5px;
    }
    .queryParam{
        float: left;
        margin: 5px 10px;
    }
    .pagination{
        border: 1px solid #e8eaec;
        width: 100%;
        padding: 5px 0;
        margin-top: 10px;
    }
    .PagingGrid{
        margin-top: -20px;
    }
    .funcButton{
        cursor: pointer;
        margin-left: 5px;
    }
</style>